module.exports = __webpack_public_path__ + "static/media/cancel.ce49abae.png";